import { render } from "./GalleryEdit.vue?vue&type=template&id=035e1234"
import script from "./GalleryEdit.vue?vue&type=script&lang=js"
export * from "./GalleryEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__